/**
 * Захирлын ханшийн мэдээлэл — hero туузан дээрх жижиг хэсэг.
 *
 * ⚠️ ЗӨВХӨН ХАРУУЛАХ. Энэ утга DB-д хадгалагдахгүй, барааны үнэ,
 *    landed cost, тайлан — юунд ч ашиглагдахгүй.
 *
 * ⚠️ Эрхийн жинхэнэ хамгаалалт нь backend дээр (`directorOnly`).
 *    Энд нуух нь зөвхөн харагдацын асуудал.
 */

import { useQuery, useQueryClient } from '@tanstack/react-query';
import { formatDateTime, formatRate } from '@boots/domain';
import { api, type Envelope } from '../lib/api';
import type { FxLive } from '../lib/types';

export function FxLiveChip() {
  const qc = useQueryClient();

  const q = useQuery({
    queryKey: ['fx-live'],
    queryFn: () => api<Envelope<FxLive>>('/ref/fx/live'),
    // Сервер талд 10 минутын cache бий — давтан асуух шаардлагагүй
    staleTime: 10 * 60 * 1000,
    retry: false,
  });

  async function refresh() {
    await qc.fetchQuery({
      queryKey: ['fx-live'],
      queryFn: () => api<Envelope<FxLive>>('/ref/fx/live?refresh=1'),
      staleTime: 0,
    });
  }

  const fx = q.data?.data;
  const busy = q.isFetching;

  return (
    <div
      className="flex min-w-[186px] flex-col gap-1 rounded-card border border-white/15
        bg-white/10 px-3.5 py-2.5 backdrop-blur-sm"
    >
      <div className="flex items-center gap-2">
        <span className="text-[10.5px] tracking-[0.12em] text-hero-ink-2 uppercase">
          Рублийн ханш
        </span>
        <button
          type="button"
          onClick={() => void refresh()}
          disabled={busy}
          title="Шинэчлэх"
          aria-label="Ханш шинэчлэх"
          className="-my-2 ml-auto grid size-11 place-items-center rounded-full
            text-hero-ink-2 transition hover:text-white disabled:opacity-40
            sm:-my-1 sm:size-9"
        >
          <span aria-hidden className={busy ? 'inline-block animate-spin' : undefined}>
            ↻
          </span>
        </button>
      </div>

      {q.isPending ? (
        <span className="num text-lg text-white/70">…</span>
      ) : fx?.rate ? (
        <span className="num text-lg leading-tight font-semibold text-white">
          1 RUB = {formatRate(fx.rate)}₮
        </span>
      ) : (
        <span className="text-[12.5px] text-white/70">Одоогоор боломжгүй</span>
      )}

      <span className="text-[10.5px] text-hero-ink-2">
        {fx?.stale
          ? 'Хуучин утга · эх сурвалж боломжгүй'
          : fx?.sourceUpdatedAt
            ? formatDateTime(fx.sourceUpdatedAt)
            : q.isError
              ? 'Татаж чадсангүй'
              : ' '}
      </span>
    </div>
  );
}
